<template>
    <menubar :permission="permission"/>
  <div class="container">

    <div id="title">
      <img class='slash' src="/img/05_slash.svg" />
      <p class="h1">ポストエディット</p>
    </div>

    <div id='post-edit-table-head'>

      <div class="post-edit-title">
        編集ファイル名：<br>
        <p class="h2"> 
          {{ bilingualFileInfo.name }} 
          <span v-if="readonly" class="post-edit-title__editing_by">
            ({{bilingualFileInfo.editing_user.name}} が編集中)
          </span>
        </p>
      </div>
      
      <button class="switch-table-view" v-on:click="switchTableView">
        <span v-bind:class="[is_simple_view ? 'active' : 'inactive']">
          原文/PE訳
        </span>
        <span v-bind:class="[!is_simple_view ? 'active' : 'inactive']">
          原文/AI訳/PE訳
        </span>
      </button>

    </div>

    <table id='post-edit-table-main' class="component_table" border="1">
      <thead>
        <tr>
          <th class="head-no">No</th>
          <th class="head-time">字幕番号</th>
          <th class="head-time">トラック</th>
          <th class="head-time">開始時間</th>
          <th class="head-time">終了時間</th>
          <th v-bind:class="[!is_simple_view ? 'head-src-text' : 'head-src-text-simple']">
            原文
          </th>
          <th v-if="!is_simple_view" class="head-ai-text">AI訳</th>
          <th v-bind:class="[!is_simple_view ? 'head-pe-text' : 'head-pe-text-simple']">
            PE訳を入力
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in bilingualFileContents" :key="item.id">
          <td class="body-no-text"> {{ item.no }}</td>
          <td class="body-no-text"> {{ item.credit_no }}</td>
          <td class="body-no-text"> {{ item.track_no }}</td>
          <td class="body-time-text"> {{ item.begin_at }}</td>
          <td class="body-time-text"> {{ item.end_at }} </td>
          <td class="body-src-text"> {{ item.src.replaceAll("_x000D_", "") }} </td>

          <td v-if="!is_simple_view" class="body-ai-text"> {{ item.trg }} </td>
          <td class="body-pe-text" v-bind:class="[ !item.pe ? 'unedited' : '']" >
            <div v-if="!readonly">
              <textarea cols="30" rows="3" v-model="item.pe" @input="resizeHeight" class="textArea__postEdit" > {{item.trg}}</textarea>
              <p class="body-pe-input">
              {{ item.pe != null ? Object.keys(item.pe).length : item.trg!=null ? item.trg.length : 0}}
              </p>
            </div>
            <div v-else>{{item.pe}}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="!readonly" class="button_close_save">
      <button class="btn btn-purple btn-close inline-block " @click="closePage">閉じる</button>
      <button class="btn btn-purple btn-save inline-block" @click="updateTranslatedFile()">保存</button>
    </div>

  </div>
  <footerComponent />
</template>

<script>
import { computed, defineComponent } from "vue";
import menubar from "@/Pages/Common/menu_wo_inertia.vue";
import modal from "@/Pages/Components/modal.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import { Inertia } from '@inertiajs/inertia'
import axios from 'axios';

export default defineComponent({
  components: {
    menubar,
    modal, 
    footerComponent,
  },
  props: {
    bilingualFileInfo: Object,
    bilingualFileContents: Array,
    permission:String,
    readonly:Boolean,
  },
  data() {
    return {
      is_simple_view: false,
    };
  },
  methods: {
    switchTableView: function (event){
      this.is_simple_view = !this.is_simple_view;
    },
    openReturnConfirmationModal: function(){
      this.$refs.returnConfirmation.openModal();
    },
    updateTranslatedFile: async function () {
      try {
        const response = await axios.patch(
          this.route('post-edit.update', this.bilingualFileInfo.id),
          { bilingualFileContents: this.bilingualFileContents }
        )
        alert(response.data.message || "保存しました。");
      } catch (error) {
        // エラーが発生した場合の処理
        if (error.response) {
          alert(error.response.data.error || "保存に失敗しました。");
        } else {
          alert("エラーが発生しました。");
        }
      }
    },
    resizeHeight:function(event){
        event.target.style.height = ( event.target.scrollHeight+2) + 'px';
    },
    discardEdit: function () {
      this.$inertia.patch(
        this.route('post-edit.update', this.bilingualFileInfo.id), 
        {discard:true},
      );
    },
    leaveEditPage: function(event){
      event.preventDefault();
      event.returnValue = '';
    },
    closePage: function() {
      window.close();
    }
  },
  created() {
    window.addEventListener('beforeunload', this.leaveEditPage);
    window.addEventListener('onpopstate', this.leaveEditPage);
    window.addEventListener("pagehide", this.discardEdit);
  },
  mounted: function(){
    if (this.readonly==true){
      const overrideUser= confirm(this.bilingualFileInfo.editing_user.name+'が編集中です。ロックを解除しますか？');
      if (overrideUser) {
        try {
          Inertia.put(route('post-edit.override', {id: this.bilingualFileInfo.id,}))
        } catch (error) {
          alert('エラーが発生しました。再試行してください。');
        }
      }
    }
  },
});
</script>

<style lang="scss" scoped>
#title {
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 3rem 0;
  img.slash{
    width: 3rem;
    height: 3rem;
  }
  p{ margin: 0 0;}
}

#post-edit-table-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .post-edit-title{
    color: #666666;
  }
  .post-edit-title__editing_by{
    font-size: 1.2rem;
  }
  .switch-table-view{
    transition: all 0.3s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: solid 1px #a07abe;
    border-radius: 100vh;
    padding: 0.2rem 0.5rem;
    background-color: white;
    color: #ece5fd;
    .active {
      background-color: #a07abe;
      color: white;
      border-radius: 100vh;
      padding: 0.175rem 0.75rem;
    }
    .inactive {
      background-color: white;
      color: #ece5fd;
      border-radius: 100vh;
      padding: 0.175rem 0.75rem;
    }
    &:hover .inactive{
      color: #763FD0;
      transition: color .3s;
    }
  }
}

#post-edit-table-main {
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {
    height: 3rem;
    .head-no{ width: 3%;}
    .head-time{ width: 7%;} //*2

    // Total 78
    .head-src-text{ width: 22%;}
    .head-ai-text{ width: 22%;}
    .head-pe-text{
      background-color: #a07abe;
      color: #ece5fd;
      width: 34%;
    }

    // Total 78
    .head-src-text-simple{ width: 34%;}
    .head-pe-text-simple{
      background-color: #a07abe;
      color: #ece5fd;
      width: 44%;
    }

    border-top: 2px;
    text-align: center;
  }
  tbody {
    text-align: center;
    td{
      padding: 1.0rem 1.0rem;
    }
    .body-no-text {
      padding: 0rem;
    }
    .body-time-text {
      padding: 1.0rem 0.5rem;
    }
    .body-src-text {
      white-space: pre-line;
      text-align: left;
      vertical-align: top;
    }
    .body-ai-text {
      white-space: pre-line;
      text-align: left;
      vertical-align: top;
    }
    .body-pe-text {
      text-align: center;
      textarea{
        width: 100%;
        display:block;
        padding: 0.3rem 0.5rem;
      }
      .body-pe-input {
        margin: 0 0 -1.3rem 0;
        text-align: right;
        position: relative; bottom: 1.4rem;
        padding: 0 0.3rem 0 0;
      }
    }
    .unedited{
      background-color: #ece5fd;
    }
  }
}

.button_close_save {
  padding: 2rem 0 2rem 0;
  display: flex;
  justify-content: center;
}
.btn-close {
  height: 2rem;
  width: 5rem;
  border: solid;
  border-color: #a07abe;
  background: #fffbf9;
  color: #a07abe;
  margin: 0 2rem 0 0;
}
.btn-save {
  height: 2.7rem;
  width: 5.69rem;
  margin: 0 0 0 2rem;
}

#return-confirmation-modal{
  .button-row{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 0.5rem 0;
  }
  .btn-continue{
    padding: 0.25rem 0;      
    button{width: 7.75rem;}
  }
  .btn-return{
    padding: 0.25rem 0;
    button{width: 7.75rem;}
  }
}
.textArea__postEdit{
  min-height: 3rem;

}
</style>
